import { render, staticRenderFns } from "./Textura.vue?vue&type=template&id=b6ba75de"
import script from "./Textura.vue?vue&type=script&lang=js"
export * from "./Textura.vue?vue&type=script&lang=js"
import style0 from "./Textura.vue?vue&type=style&index=0&id=b6ba75de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports